import React from "react";
import PageLayout from "../ui/PageLayout";
import PageHero from "../ui/PageHero";
import ProseSection from "../ui/ProseSection";

const sections = [
  {
    title: "Who we are",
    body: "Our website address is: http://kindnessunlimited.in/.",
  },
  {
    title: "What personal data we collect and why we collect it",
    body: "We collect email address, phone numbers and the names of individuals based on whether they contact us via the Contact Us page or if they are applying for an Internship via the Internship Programme page. Collection is necessary so we can maintain and establish contact with our visitors and applicants. We only collect data sent by the users themselves.",
  },
  {
    title: "Media",
    body: "If you upload images to the website, you should avoid uploading images with embedded location data (EXIF GPS) included. Visitors to the website can download and extract any location data from images on the website.",
  },
  {
    title: "Contact forms",
    body: "We use contact forms to collect feedback and information regarding internships. We collect names, email and phone numbers from the forms to establish contact with the applicants. We do not use personal information for any marketing related businesses.",
  },
  {
    title: "Cookies",
    body: `If you leave a comment on our site you may opt-in to saving your name, email address and website in cookies. These are for your convenience so that you do not have to fill in your details again when you leave another comment. These cookies will last for one year.

If you visit our login page, we will set a temporary cookie to determine if your browser accepts cookies. This cookie contains no personal data and is discarded when you close your browser.

When you log in, we will also set up several cookies to save your login information and your screen display choices. Login cookies last for two days, and screen options cookies last for a year. If you select "Remember Me", your login will persist for two weeks. If you log out of your account, the login cookies will be removed.

If you edit or publish an article, an additional cookie will be saved in your browser. This cookie includes no personal data and simply indicates the post ID of the article you just edited. It expires after 1 day.`,
  },
  {
    title: "Embedded content from other websites",
    body: `Articles on this site may include embedded content (e.g. videos, images, articles, etc.). Embedded content from other websites behaves in the exact same way as if the visitor has visited the other website.

These websites may collect data about you, use cookies, embed additional third-party tracking, and monitor your interaction with that embedded content, including tracking your interaction with the embedded content if you have an account and are logged in to that website.`,
  },
  {
    title: "How long we retain your data",
    body: `If you leave a comment, the comment and its metadata are retained indefinitely. This is so we can recognize and approve any follow-up comments automatically instead of holding them in a moderation queue.

For users that register on our website (if any), we also store the personal information they provide in their user profile. All users can see, edit, or delete their personal information at any time (except they cannot change their username). Website administrators can also see and edit that information.`,
  },
  {
    title: "What rights you have over your data",
    body: "If you have an account on this site, or have left comments, you can request to receive an exported file of the personal data we hold about you, including any data you have provided to us. You can also request that we erase any personal data we hold about you. This does not include any data we are obliged to keep for administrative, legal, or security purposes.",
  },
  {
    title: "Where we send your data",
    body: "Visitor comments and forms may be checked through an automated spam detection service.",
  },
  {
    title: "Contact Information",
    body: "Mail: contactus@kindnessunlimited.in\n\nPhone: 9820710081",
  },
];

const PrivacyPolicy = () => (
  <PageLayout showStickyDonate={false}>
    <PageHero title="Privacy Policy" light />
    <ProseSection>
      {sections.map((section) => (
        <div key={section.title} className="mb-10">
          <h2 className="font-display text-2xl font-bold text-ku-royal mb-4">{section.title}</h2>
          {section.body.split("\n\n").map((para, i) => (
            <p key={i}>{para}</p>
          ))}
        </div>
      ))}
    </ProseSection>
  </PageLayout>
);

export default PrivacyPolicy;
